import initPromoLink from '../../shared/promo_link/promo_link'
import countdownClock from '../../utils/countdown'
import { sendHeadbandUtagEvent } from './headband.analytics'
import { currentPageType } from '../../utils/page_type_detector';

const ACTIVE_STICKY_HEADBANDS_CLASS = '.js-headband.sticky.slide-down'

function showHeadbandCountdown(headband) {
  const now = new Date()
  const countdownStart = new Date(headband.dataset.countdownStart)
  const countdownEnd = new Date(headband.dataset.countdownEnd)
  const countdown = headband.querySelector('.js-countdown')
  const expiredText = JSON.parse(countdown.dataset.translations).expired
  
  if (now >= countdownStart) {
    countdown.classList.remove('hidden')
    countdownClock(1000, 9999)

    if (expiredText === '' && now >= countdownEnd) {
      countdown.remove()
    }
  }
}

function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function cleanUnusedHeadbands() {
  document.querySelectorAll('.js-headband:not(.slide-down)').forEach(hiddenHeadband => {
    hiddenHeadband.remove()
  })
}

function isHeadbandInTime(headband) {
  const now = new Date()
  const start = new Date(headband.dataset.start)
  const end = new Date(headband.dataset.end)

  if (now >= start && now <= end) {
    return true
  }
}

function getTotalHeadbandsHeight(sticky = undefined) {
  const selector = sticky === undefined ? '.js-headband.slide-down' : (sticky ? '.js-headband.slide-down.sticky' : '.js-headband.slide-down:not(.sticky)');
  const headbands = document.querySelectorAll(selector);
  const totalHeight = Array.from(headbands).reduce(
    (total, headband) => total + headband.clientHeight,
    0
  );
  return totalHeight;
}

function slideDownHeadband(headband, callback) {
  headband.classList.add('slide-down')
  headband.addEventListener('transitionend', callback, { once: true })
}

async function loopHeadbands(headbands) {
  for (const headband of headbands) {
    const unlockMetrics = headband.dataset.metrics;

    if (isHeadbandInTime(headband)) {
      showHeadbandCountdown(headband);
      removeMobilePadding();
      slideDownHeadband(headband, () => {
        updateHeaderPosition();
        updateSectionStyles();
      });

      const promoLinkElement = headband.querySelector('.js-promolink');
      if (unlockMetrics === 'true') {
        attachPromoLinkEvent(promoLinkElement);
      }
      initPromoLink(promoLinkElement);
    }
  }
}

function removeMobilePadding() {
  document.body.style.paddingTop = '0px';
}

function updateBurgerMenuPosition() {
  const allHeadbandsHeight = getTotalHeadbandsHeight()
  const burgerMenu = document.querySelector('.mobile-burger-menu.burgermenu-right');
  const burgerMenuPanel = document.querySelector('.burgermenu-panel');
  burgerMenu.style.paddingTop = `${allHeadbandsHeight + 60}px`
  burgerMenuPanel.style.paddingTop = `${allHeadbandsHeight + 60}px`
}

function updateSectionStyles() {
  const section = document.querySelector('section');
  const totalNonStickyHeight = getTotalHeadbandsHeight(false);
  if (section && isMobileDevice()) {
    updateBurgerMenuPosition()
    if (totalNonStickyHeight > 0) {
      section.style.transition = 'all 1s ease-in-out';
      section.style.paddingTop = `60px`
    }
  }
}

function attachPromoLinkEvent(promoLinkElement) {
  promoLinkElement.addEventListener('click', function () {
    sendHeadbandUtagEvent(promoLinkElement.closest('.headband'));
  });
}

function pushBody() {
  const totalStickyHeight = getTotalHeadbandsHeight(true);
  const totalNonStickyHeight = getTotalHeadbandsHeight(false);
  document.body.style.transition = 'all 1s ease-in-out'
  document.body.style.position = 'relative'

  if (isMobileDevice() && (totalStickyHeight === 0 || totalNonStickyHeight === 0)) {
    document.body.style.paddingTop = `${totalStickyHeight + 60}px`
  } else if (isMobileDevice() && (totalStickyHeight < 0 && totalNonStickyHeight < 0)) {
    document.body.style.paddingTop = `${totalStickyHeight}px`
  } else {
    document.body.style.paddingTop = `${totalStickyHeight}px`
  }
}

function updateHeaderPosition() {
  const header = document.getElementById('header');
  const totalAllHeight = getTotalHeadbandsHeight();
  const totalStickyHeight = getTotalHeadbandsHeight(true);
  const scrollY = window.scrollY;
  header.style.transition = 'all 1s ease-in-out'
  header.style.top = totalAllHeight + 'px';

  if (scrollY && totalStickyHeight >= 0) { 
    header.style.top = totalStickyHeight + 'px';
  }
}

const TRIGGER_SELECTOR_MOBILE = '.mobile-fastbooking .open-mobile-panel'

function openFastbookingPanel() {
  let $body = $('body')
  let $fastbooking = $('.fastbooking.home')
  let $fastbooking_original_wrapper = $fastbooking.parent()
  let wrapper_height = $fastbooking_original_wrapper.outerHeight()
  let $overlay = $('<div>').addClass('fastbooking-overlay-wrapper')
  $overlay.appendTo($body).append($fastbooking);
  $fastbooking_original_wrapper.css('height', wrapper_height);
  $('html, body').addClass('fastbooking-overlay-wrapper-shown');
  let headbandHeight = $('.js-headband').outerHeight()
  $fastbooking.css('margin-top', headbandHeight + 'px');

  $(document).on('click', '.fastbooking-overlay-wrapper', function(event) {
    const target = event.target;
    if (target.classList.contains('fastbooking-overlay-wrapper')) {
      $fastbooking_original_wrapper.append($fastbooking).css('height', '');
      $overlay.remove();
      $('html, body').removeClass('fastbooking-overlay-wrapper-shown');
      $fastbooking.css('margin-top', '0px');
      $('.focus').remove();
    }
  });
}


function openPanelDestination() {
  if(isMobileDevice()) {
    // Open FB
    const openMobilePanel = document.querySelector(`${TRIGGER_SELECTOR_MOBILE}`)
    openMobilePanel.click()
    
    // Init Panel Destination
    const fastbooking = document.querySelector('.js-mobile-fastbooking')
    
    // Once initialised, call the event to open the panel.
    const select = fastbooking.querySelector('.chosen-select');
    const event = new CustomEvent('chosen:open', { bubbles: true });
    select.dispatchEvent(event);

    // Open destination panel
    setTimeout(() => {
      $('.fake-select').click();
      $('.chosen-container').trigger('mousedown')
    }, 100);
  } else {
    openFastbookingPanel()
    setTimeout(() => {
      $('.fake-select, .fake-select-click').click();
    }, 50);
  }
}

function openPanelDates() {
    if(isMobileDevice()) {
      // Open FB
      const openMobilePanel = document.querySelector(`${TRIGGER_SELECTOR_MOBILE}`)
      openMobilePanel?.click()

      setTimeout(() => {
        $('.dates-container-js .fake-datepicker').click()
      }, 500);
      
    } else {
      document.querySelector('.fastbooking.home').scrollIntoView({
          block: 'center',
          behavior: 'smooth',
      });
      
      setTimeout(() => {
        $('.dates-fast-js-cnt').click()
      }, 500);
    }
}

function handlerLinkFastbooking(headband) {
  if(!headband) return
  
  const linkFastBooking = headband.querySelector('.btn-floating-fastbooking')

  linkFastBooking.addEventListener('click', (event) => {
    event.stopPropagation();
    
    if (!$('.fastbooking').length) return;

    if(!currentPageType.isGeneric()) {
      openPanelDestination()
    } else {
      openPanelDates()
    }
  })
}

function setStickyHeadbandsPositions() {
  const stickyHeadbands = document.querySelectorAll(ACTIVE_STICKY_HEADBANDS_CLASS)
  stickyHeadbands.forEach((headband, index) => {
    const previousHeadband = stickyHeadbands[index - 1]
    if (previousHeadband) {
      headband.style.top = `${previousHeadband.clientHeight}px`
    }
  })
}

export default function init() {
  const allHeadbands = document.querySelectorAll('.js-headband')
  const stickyHeadbands = Array.from(allHeadbands).find(headband => headband.classList.contains('sticky'))

  if (!allHeadbands) return

  loopHeadbands(allHeadbands)
  cleanUnusedHeadbands()

  if (stickyHeadbands) {
    setStickyHeadbandsPositions()
    slideDownHeadband(stickyHeadbands, () => {
      pushBody()
    })
    handlerLinkFastbooking(stickyHeadbands);
  }
}

window.addEventListener('scroll', updateHeaderPosition);

document.addEventListener('DOMContentLoaded', () => {
  requestIdleCallback(init)
})
